import React, {useEffect} from "react";
import LoadingSpinner from "../GUI_COMMON/COMPONENTS/LoadingSpinner";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {useParams} from "react-router-dom";
import ArchiverClientApi from "../API/archiverClientApi";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";
import Header from "./Header";
import BackButton from "../GUI_COMMON/COMPONENTS/BackButton";
import {useCookies} from "react-cookie";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";
import ReactDOMServer from "react-dom/server";

class MagHistoryItem {
    id: number;
    date: string;
    actionVerb: string;
    actor: string;
    note: string;
}

export const MagHistoryPage = () => {
    
    const [isSearchingHistory, setIsSearchingHistory] = React.useState(false);
    const [magHistory:MagHistoryItem[], setMagHistory] = React.useState([]);

    const {magBC} = useParams();
    const [cookies,]= useCookies();

    useEffect(() => {
        // RECALL -- this runs AFTER all children mount!
        console.debug("MagHistoryPage starting up...");
        window.scrollTo(0,0);
        LIUtils.setBackgroundColor('--li-main-bg-color');

        getMagHistory(magBC);

    }, [magBC]);  // eslint-disable-line react-hooks/exhaustive-deps

    function getMagHistory(magBC:string,  magId:string) {
        setIsSearchingHistory(true);
        setMagHistory([]);
        ArchiverClientApi.getMagHistory(magBC)
        .then( (magHistory:MagHistoryItem[]) => {
            setMagHistory(magHistory);
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => setIsSearchingHistory(false));
    }

    function historyLinkClickHandler(note: Element, sampleId: number) {
        if(!note) return;
        //ArchiverClientApi.sendNotifySampleLocationViewed(sampleId,"Case Details"); // fire and forget
        Popup.showInfo(ReactDOMServer.renderToString(note), true);
    }

    function showHistoryTable() {
        if (magHistory.length === 0) {
            return <div className="card">{isSearchingHistory?<LoadingSpinner medium center/>:"No history found"}</div>;
        }

        const resultList = magHistory.map((item, index) =>
            <tr className="text-left" key={item.id}>
                <td width="200px">{LIUtils.shortDateTimeFromJsonUtcDateStr(item.date)}</td>
                <td width="250px">{item.actionVerb}</td>
                <td>{item.actor}</td>
                <td style={{whiteSpace: 'pre-line'}}>
                    {LIUtils.translateHistoryNote(item.note, LIUtils.UserCanSeeSampleLocation(cookies), historyLinkClickHandler)}
                </td>
            </tr>
        );

        return (
            <table className="table table-striped">
                <thead>
                    <tr className="text-left"><th width="160px">Date</th><th className="50px text-wrap">Action</th><th width="200px">Who</th><th>Note</th></tr>
                </thead>
                <tbody>
                    {resultList}
                </tbody>
            </table>
        );
    }

    return (<div className="container">
                <Header title={"Mag History - "+magBC}/>
                <div className="row mt-3 li-header-row justify-content-between">
                    <div>
                        <span style={{verticalAlign:"top"}}><BackButton/></span>
                        <div className="d-inline-block">
                            <div className="">
                                <span className="li-font-huge m-0 p-0">Mag History:</span>
                                <span className="li-font-large li-fg-primary ml-2 align-self-center">{magBC??"-"}</span>
                            </div>
                        </div>
                    </div>
                    {/*<div className="li-font-small text-right my-auto ml-auto mr-3">[id: {magId}]</div>*/}
                </div>
            
                <div className="mb-5">
                    <div className="li-font-huge">History</div>
                    <div className="li-search-results-table">
                        {showHistoryTable()}
                    </div>
                </div>
            </div>
        );
};